module.exports = __webpack_public_path__ + "img/12.2c16bcf2.png";